import React from "react";
import { connect } from "react-redux";
import { useQuery } from "@apollo/client";
import { GET_REGISTRATION_NUMBER_DETAILS } from "./queries";
import { client } from "../../../../index";
import "../caseDetails.scss";
import { StatusPill } from "../../../../global/css/component/Table";
import { labelResolver, valueResolver } from "./resolvers";
import { Grid, P, CaseValue } from "./styles";
import { ReadMore } from "./components";
import {
  LinkBack,
  isDataRenderable,
  isPropertyRenderable,
} from "../CaseDetailUtils";
import CaseLinkedCasesTables from "../CaseDetailsTables/CaseLinkedCasesTables";

const CaseDetailRegistrationNumber = ({
  formId,
  registrationNumber,
  location,
}) => {
  const {
    // loading,
    data: { getRegistrationNumberDetails: data = {} } = {},
  } = useQuery(
    GET_REGISTRATION_NUMBER_DETAILS,
    {
      variables: {
        registrationNumber,
        formId,
      },
    },
    client
  );

  const DataGrid = ({ data, formId }) => {
    return (
      <Grid>
        {data &&
          Object.keys(data).map((key) => {
            return <DataItem data={data[key]} dataKey={key} formId={formId} />;
          })}
      </Grid>
    );
  };

  const componentWrapperResolver = (dataKey, value, formId) => {
    const map = {
      status: function () {
        value = value ? value.toLowerCase() : "";
        return (
          <StatusPill status={value}>
            <span style={{ padding: "5px 10px" }}>{value}</span>
          </StatusPill>
        );
      },
      tempneedDescription: function () {
        return (
          <ReadMore
            text={value}
            textStyle={{ fontWeight: "bold" }}
            // trimLength={10}
          />
        );
      },
    };
    return map[dataKey] ? map[dataKey]() : value;
  };

  const DataItem = ({ data, dataKey, formId }) => {
    if (isPropertyRenderable(dataKey) && isDataRenderable(data)) {
      const label = labelResolver(dataKey, formId);
      const value = valueResolver(dataKey, data, formId);
      const Component = componentWrapperResolver(dataKey, value, formId);
      return (
        <P className={`data-item-${dataKey}`}>
          {label}: <CaseValue>{Component}</CaseValue>
        </P>
      );
    } else {
      return null;
    }
  };

  const TabNav = () => {
    return (
      <div
        className="navigation tablet:grid-col-12"
        style={{ paddingBottom: "15px" }}
      >
        <a
          role="tab"
          aria-controls={"linkedCases"}
          className="nav-item active"
          href="#"
        >
          Linked Cases
        </a>
      </div>
    );
  };

  return (
    <div className="profiles-details-container">
      <div className="header-container">
        <div className="header-content">
          <LinkBack location={location} />

          <hr />

          <DataGrid data={data} formId={formId} />
        </div>
      </div>

      <div className="content-container">
        <div className="grid-row">
          <TabNav />
        </div>

        <div className="grid-row">
          {data?.linkedCases && (
            <CaseLinkedCasesTables data={data.linkedCases} />
          )}
        </div>
      </div>
    </div>
  );
};

export default CaseDetailRegistrationNumber;
